import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function matchAcceptRule(file: File, rule: string) {
  if (!rule) {
    return true
  }

  if (rule.startsWith('.')) {
    return file.name.toLowerCase().endsWith(rule.toLowerCase())
  }

  if (rule.endsWith('/*')) {
    return file.type.startsWith(rule.slice(0, -1))
  }

  return file.type === rule
}

export function matchesAccept(file: File, accept: string) {
  if (!accept.trim()) {
    return true
  }

  return accept
      .split(',')
      .map((rule) => rule.trim())
      .filter(Boolean)
      .some((rule) => matchAcceptRule(file, rule))
}

export function dataURLtoFile(dataurl: string, filename: string) {
  const arr = dataurl.split(",")
  const mimeMatch = arr[0].match(/:(.*?);/)
  const mime = mimeMatch ? mimeMatch[1] : "image/png"
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}